// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__39cvr","log":"ModalInventoryLogs_log__1NI8u","date":"ModalInventoryLogs_date__lfQ6F","userName":"ModalInventoryLogs_userName__2iaMl"};